const component = () => {
	return (
		<div id = "control-height"
			style  = { {
				height   : "100vh",
				width    : 0,
				position : "absolute"
			} }
		/>
	);
};

export default component;